import React from "react";
import classes from './Card.module.css';

const Card = ({className, disabled, hover, children, ...props}) => {
    return (
        <div 
            className={
                `card 
                ${className} 
                ${disabled ? classes.cardDisabled:classes.card} 
                ${(hover && !disabled) ? classes.cardHover:''}`
            } 
            {...props}>
            {children}
        </div>
    );
}

export default Card;